import { render, staticRenderFns } from "./Demand.vue?vue&type=template&id=b73826ae&scoped=true&"
import script from "./Demand.vue?vue&type=script&lang=js&"
export * from "./Demand.vue?vue&type=script&lang=js&"
import style0 from "./Demand.vue?vue&type=style&index=0&id=b73826ae&prod&scoped=true&lang=css&"
import style1 from "./Demand.vue?vue&type=style&index=1&id=b73826ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73826ae",
  null
  
)

export default component.exports